export enum MetaDataHolder {
  ACCOUNT = 'ACCOUNT',
  OMS = 'OMS',
  SERVICE = 'SERVICE',
  TASK = 'TASK',
  FULFILLMENT = 'FULFILLMENT',
  THIRDPARTYSERVICE = 'THIRD_PARTY_SERVICE',
  ROUTE = 'ROUTE',
  FULFILLMENT_STEP = 'FULFILLMENT_STEP',
}
